export default __webpack_public_path__ + "static/media/img_awaiting_stream_en.cc9e26b8.jpg";